import { render, staticRenderFns } from "./progressbudget_project.vue?vue&type=template&id=112c06f4"
import script from "./progressbudget_project.vue?vue&type=script&lang=js"
export * from "./progressbudget_project.vue?vue&type=script&lang=js"
import style0 from "./progressbudget_project.vue?vue&type=style&index=0&id=112c06f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports